import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import {
    GetVoucherPreselectedPackage,
    GetVoucherPreselectedPackageResponse
} from '../api/dtos';

const getData = (
    response?: SWRResponse<GetVoucherPreselectedPackageResponse, GetVoucherPreselectedPackageResponse>
) => response?.data;

const getError = (
    response?: SWRResponse<GetVoucherPreselectedPackageResponse, GetVoucherPreselectedPackageResponse>
) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (
    response?: SWRResponse<GetVoucherPreselectedPackageResponse, GetVoucherPreselectedPackageResponse>
) => ({
    preselectedPackageSessionIds: response?.data?.preselectedPackageSessionIds,
    packageId: response?.data?.packageId
});

export const useVoucherPreselectedPackage = (code?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!code) {
            return undefined;
        }

        return () => new GetVoucherPreselectedPackage({ code });
    }, [code]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
};

export default useVoucherPreselectedPackage;